export default "__VITE_ASSET__TB0YFtoI__"